module.exports = __webpack_public_path__ + "static/media/cloud-download.9bc8ced1.svg";